import { render, staticRenderFns } from "./BuddhismSubsidy.vue?vue&type=template&id=49ad1784&scoped=true"
import script from "./BuddhismSubsidy.vue?vue&type=script&lang=js"
export * from "./BuddhismSubsidy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ad1784",
  null
  
)

export default component.exports